// 文件上传相关常量配置
export const FILE_UPLOAD_CONSTANTS = {
  // 文件上传数量限制
  MAX_FILE_COUNT: 10,
  
  // 文件大小限制 (10MB)
  MAX_FILE_SIZE: 10 * 1024 * 1024,
  
  // 文件大小限制描述 (用于显示)
  MAX_FILE_SIZE_MB: 10
};

// 组织相关常量配置
export const ORGANIZATION_CONSTANTS = {
  // 特殊组织ID - 用于判断是否显示特定的模型列表
  COCOROBO_ORG_ID: '45facc0a-1211-11ec-80ad-005056b86db5',
  // COCOROBO_ORG_ID: '45facc0a-1211-11ec-80ad-005056b86db1',
  // 需要执行特定限制（隐藏入口、精简 Tab 等）的组织 ID 列表
  // RESTRICTED_ORG_IDS: ['45facc0a-1211-11ec-80ad-005056b86db5'],
  RESTRICTED_ORG_IDS: ['28aae58a-cab3-11f0-a424-005056924926'],
  // 仅展示的 Header Tab value 列表
  LIMIT_HEADER_TAB_VALUES: [1, 2],
  // 受限组织默认跳转的 Tab value
  RESTRICTED_ORG_DEFAULT_TAB: 1,
  // 学生用户类型(type=2)默认跳转的 Tab value
  STUDENT_DEFAULT_TAB: 1,
  // 受限组织的模型列表配置
  // label: 实际传递的参数
  // nameKey: lang 对象中的 key，用于查找对应的名字（支持多语言）
  //   如果 lang 中没有对应的 key，则使用 nameKey 作为展示名字
  RESTRICTED_ORG_MODEL_LIST: [
    { label: "open-doubao", nameKey: "doubao" },
    { label: "open-Pro/deepseek-ai/DeepSeek-V3", nameKey: "DeepSeek" },
    { label: "open-Pro/deepseek-ai/DeepSeek-R1", nameKey: "DeepSeek-R1" },
    // { label: "open-glm-4.5", nameKey: "glm_4_5" },
    // { label: "open-qwen-plus-latest", nameKey: "thousand_questions_latest" },
    // { label: "open-qwen3-coder-plus", nameKey: "qwen3_coder_plus" },
    // { label: "open-hunyuan-turbo", nameKey: "hunyuan_turbo" },
    // { label: "open-hunyuan-t1-latest", nameKey: "hunyuan_t1_latest" },
  ],

  // 额外组织的模型列表配置（非受限组织，在默认列表基础上按 organizeId 覆盖）
  // key: organizeId
  // value: [{ label, nameKey }, ...]  —— 与 buildModelList 入参保持一致
  ADDITIONAL_ORG_MODEL_LISTS: {
    // 香港教育大学
    "7e23aac4-4aff-11ef-b873-005056b86db5": [
      { label: "open-gpt-5.1", nameKey: "GPT-5.1" },
    ],
    // 示例：
    // 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx': [
    //   { label: "open-doubao", nameKey: "doubao" },
    //   { label: "open-Pro/deepseek-ai/DeepSeek-V3", nameKey: "DeepSeek" },
    // ],
  },
};

// 用户类型相关常量配置
export const USER_TYPE_CONSTANTS = {
  // 学生用户类型
  STUDENT_TYPE: 2,
};

// AI模型相关常量配置
export const AI_MODEL_CONSTANTS = {
  // 默认模型
  DEFAULT_MODEL: 'gpt-4o-2024-11-20',
  // 建议生成专用模型
  // SUGGESTION_MODEL: 'glm-4.5-flash'
  // SUGGESTION_MODEL: 'qwen-flash'
  SUGGESTION_MODEL: 'qwen3-max'
};

// 客服智能体相关常量
// export const CUSTOMER_SUPPORT_AGENT_ID_FALLBACK = '9ba6e501-fbbf-4134-ab7c-88b091b5c383';
export const CUSTOMER_SUPPORT_AGENT_ID_FALLBACK = '89533e47-1f4d-4a91-b91a-fe5c3e9392bf';
export const CUSTOMER_SUPPORT_AGENT_ID =
  process.env.VUE_APP_CUSTOMER_SUPPORT_AGENT_ID || CUSTOMER_SUPPORT_AGENT_ID_FALLBACK;

// 导出默认配置
export default FILE_UPLOAD_CONSTANTS;
